module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kj-Lc.797ace0d.png";